<script>
export default {
  props: {
    module: Object,
  },
};
</script>
<template>
  <Card
    v-if="module"
    class="p-t-c-ii"
  >
    <CardTitle>{{ module.name }}</CardTitle>
    <CardBody flex>
      <div class="p-t-c-ii__preview">
        <img
          v-if="module.preview"
          :src="module.preview"
          alt=""
        >
      </div>
      <div class="p-t-c-ii__info">
        <div class="p-t-c-ii__group">
          <span>Направление:</span>
          {{ module.country | label}} -
          {{ module.city | label}}
        </div>
        <div class="p-t-c-ii__group">
          <span>Даты:</span>
          {{ module.labelDate }}
        </div>
        <div
          class="p-t-c-ii__group"
        >
          <span>Тип тура:</span>
          {{ module.type | label }}
        </div>
        <div class="p-t-c-ii__group">
          <span>Туристы:</span>
          {{ module.labelTourist }}
        </div>
        <div class="p-t-c-ii__group">
          <span>Описание:</span>
          <div class="p-t-c-ii__description">
            {{ module.description }}
          </div>
        </div>
      </div>
    </CardBody>
    <CardBody style="padding-top: 16px;" v-if="module.services.length">
      <div class="p-t-c-ii__group">
        <span>Услуги:</span>
        <div class="p-t-c-ii__description">
          <div
            v-for="(service, idx) in module.services"
            :key="idx"
          >
            {{ service }}
          </div>
        </div>
      </div>
    </CardBody>
  </Card>
</template>
<style lang="scss">
  .p-t-c-ii {
    &__group {
      margin-bottom: 8px;
      font-size: 16px;

      span {
        display: inline-block;
        width: 150px;
        font-weight: 700;
      }
    }

    &__preview {
      width: 180px;
      height: 180px;
      margin-right: 16px;
      flex-shrink: 0;
      line-height: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  @media (max-width: 600px) {
    .p-t-c-ii {
      .card-body--flex {
        display: block;
      }
    }
    .p-t-c-ii__preview {
      width: 100%;
      margin: 0 0 16px 0;
    }
  }
</style>
